<template>
<div style="height:100vh" class="d-flex flex-column align-center justify-center ma-4">
      <h1 class="text-center">{{$t("auth.callback.login")}}</h1>
      <v-img
        contain
        alt="Image de l'ours Genius"
        max-height="500px"
        height="100vh"
        src="/media/svg/illustrations/TMG_ours-fusee-qui-vole.gif"
      >
      </v-img>
</div>
</template>
<style>
body {
  background:white;
}
  </style>
<script>
import { LOGIN_SSO, LOGOUT_NO_REDIRECT } from "@/core/services/store/auth.module";
export default {
  name: "LoginCallback",
  mounted() {
    let params = this.getAllUrlParams();
    let client = localStorage.getItem('auth_client');
    // ----------------------------------------------------------------
    // Vérification si des paramètres sont bien présents
    // ----------------------------------------------------------------
    if(!params){
      localStorage.setItem("auth_errors", JSON.stringify([{"message" : "invalid_parameters"}]));
      return this.$router.push({ name: "login" });
    }
    // Vérification si erreurs retournées
    if(params["error"]){
      localStorage.setItem("auth_errors", JSON.stringify([{"message" : this.tryDecodeUriComponent(params["error"])}]));
      return this.$router.push({ name: "login" });
    }
    // Vérification si le client est renseigné
    if(!client){
      localStorage.setItem("auth_errors", JSON.stringify([{"message" : "invalid_client"}]));
      return this.$router.push({ name: "login" });
    }
    // ----------------------------------------------------------------
    // Gestion des redirections en fonctions des cas
    // ----------------------------------------------------------------
    params["client"] = client;
    // Suppression de précédent identifiant
    this.$store.dispatch(LOGOUT_NO_REDIRECT);
    // Demande de connexion avec les paramètres récupérés
    this.$store.dispatch(LOGIN_SSO, params)
    .then(() => {  this.$router.push({ name: "tableauDeBord" }) })
    .catch(() => {   this.$router.push({ name: "login" }) });
  },
  methods: {
    getAllUrlParams(url) {
      // get query string from url (optional) or window
      var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

      // we'll store the parameters here
      var obj = {};

      // if query string exists
      if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
          // separate the keys and the values
          var a = arr[i].split('=');

          // set parameter name and value (use 'true' if empty)
          var paramName = a[0];
          var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

          // if the paramName ends with square brackets, e.g. colors[] or colors[2]
          if (paramName.match(/\[(\d+)?\]$/)) {

            // create key if it doesn't exist
            var key = paramName.replace(/\[(\d+)?\]/, '');
            if (!obj[key]) obj[key] = [];

            // if it's an indexed array e.g. colors[2]
            if (paramName.match(/\[\d+\]$/)) {
              // get the index value and add the entry at the appropriate position
              var index = /\[(\d+)\]/.exec(paramName)[1];
              obj[key][index] = paramValue;
            } else {
              // otherwise add the value to the end of the array
              obj[key].push(paramValue);
            }
          } else {
            // we're dealing with a string
            if (!obj[paramName]) {
              // if it doesn't exist, create property
              obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === 'string'){
              // if property does exist and it's a string, convert it to an array
              obj[paramName] = [obj[paramName]];
              obj[paramName].push(paramValue);
            } else {
              // otherwise add the property
              obj[paramName].push(paramValue);
            }
          }
        }
      }

      return obj;
    },
    tryDecodeUriComponent(component) {
        try{
          return decodeURI(component);
        }catch(e){
            return component
        }
    }
  },

};
</script>
